import { render, staticRenderFns } from "./ToolbarImage.vue?vue&type=template&id=61a6bcfc&"
import script from "./ToolbarImage.vue?vue&type=script&lang=js&"
export * from "./ToolbarImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports